<template>
  <div class="app-container">
    <div class="head-container">
      <el-input
        v-model="query.baseName"
        clearable
        size="small"
        placeholder="底座名称"
        style="width: 160px; margin-right: 8px;"
        @keyup.enter.native="loadList"
      />
      <el-input
        v-model="query.baseCode"
        clearable
        size="small"
        placeholder="底座编码"
        style="width: 140px; margin-right: 8px;"
        @keyup.enter.native="loadList"
      />
      <el-select
        v-model="query.status"
        clearable
        size="small"
        placeholder="状态"
        style="width: 110px; margin-right: 8px;"
      >
        <el-option label="启用" :value="1" />
        <el-option label="停用" :value="0" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" size="small" @click="loadList">查询</el-button>
      <el-button icon="el-icon-refresh" size="small" @click="resetQuery">重置</el-button>
      <el-button type="primary" icon="el-icon-plus" size="small" @click="openForm()">新增底座</el-button>
    </div>

    <el-table v-loading="loading" :data="list" size="small" border style="width:100%;margin-top:12px;">
      <el-table-column prop="baseCode" label="编码" width="130" show-overflow-tooltip />
      <el-table-column prop="baseName" label="底座名称" min-width="120" show-overflow-tooltip />
      <el-table-column label="外观图" width="88" align="center">
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.appearanceImage"
            :src="toFullUrl(scope.row.appearanceImage)"
            :preview-src-list="[toFullUrl(scope.row.appearanceImage)]"
            fit="contain"
            style="width:48px;height:48px;"
          />
          <span v-else style="color:#c0c4cc;">—</span>
        </template>
      </el-table-column>
      <el-table-column label="L×W×H(mm)" min-width="140" align="center">
        <template slot-scope="scope">
          {{ fmt(scope.row.bottomLength) }}×{{ fmt(scope.row.bottomWidth) }}×{{ fmt(scope.row.bottomHeight) }}
        </template>
      </el-table-column>
      <el-table-column prop="color" label="章体色" width="80" show-overflow-tooltip />
      <el-table-column prop="weight" label="重量(g)" width="80" align="center" />
      <el-table-column prop="material" label="材质" width="90" show-overflow-tooltip />
      <el-table-column label="状态" width="72" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="mini">
            {{ scope.row.status === 1 ? '启用' : '停用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120" align="center" fixed="right">
        <template slot-scope="scope">
          <div class="op-btns">
            <el-button type="text" size="mini" @click="openForm(scope.row)">编辑</el-button>
            <el-button type="text" size="mini" class="op-del" @click="handleDelete(scope.row)">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      style="margin-top:16px;text-align:right;"
      background
      layout="total, prev, pager, next, sizes"
      :current-page="query.page + 1"
      :page-size="query.size"
      :page-sizes="[10, 20, 50]"
      :total="total"
      @current-change="handlePageChange"
      @size-change="handleSizeChange"
    />

    <el-dialog
      :title="form.id ? '编辑印章底部' : '新增印章底部'"
      :visible.sync="formVisible"
      width="720px"
      :close-on-click-modal="false"
      @closed="resetForm"
    >
      <el-form ref="formRef" :model="form" :rules="rules" size="small" label-width="120px">
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="底座名称" prop="baseName">
              <el-input v-model="form.baseName" maxlength="128" placeholder="如：标准四指底座" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="底座编码">
              <el-input v-model="form.baseCode" maxlength="32" placeholder="留空自动生成" :disabled="!!form.id" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="长度(mm)">
              <el-input-number v-model="form.bottomLength" :min="0" :precision="2" :step="0.1" style="width:100%;" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="宽度(mm)">
              <el-input-number v-model="form.bottomWidth" :min="0" :precision="2" :step="0.1" style="width:100%;" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="高度(mm)">
              <el-input-number v-model="form.bottomHeight" :min="0" :precision="2" :step="0.1" style="width:100%;" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="重量(g)">
              <el-input-number v-model="form.weight" :min="0" :precision="2" :step="1" style="width:100%;" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="材质">
              <el-input v-model="form.material" maxlength="64" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="颜色（章体）">
              <el-input v-model="form.color" maxlength="64" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="外观图">
              <admin-single-image-upload v-model="form.appearanceImage" :width="120" :height="120" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" prop="status">
              <el-radio-group v-model="form.status">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input v-model="form.remark" type="textarea" :rows="2" maxlength="512" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="formVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="saving" @click="submitForm">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AdminSingleImageUpload from '@/pages/admin/components/AdminSingleImageUpload.vue'
import { fetchSealBases, createSealBase, updateSealBase, deleteSealBase } from '@/api/h5-admin-seal-stock'

function emptyForm() {
  return {
    id: null,
    baseCode: '',
    baseName: '',
    appearanceImage: '',
    bottomLength: null,
    bottomWidth: null,
    bottomHeight: null,
    weight: null,
    material: '',
    color: '',
    status: 1,
    sort: 0,
    remark: ''
  }
}

export default {
  name: 'H5AdminSealBase',
  components: { AdminSingleImageUpload },
  data() {
    return {
      loading: false,
      saving: false,
      list: [],
      total: 0,
      query: { page: 0, size: 10, baseName: '', baseCode: '', status: null },
      formVisible: false,
      form: emptyForm(),
      rules: {
        baseName: [{ required: true, message: '请填写底座名称', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      }
    }
  },
  created() {
    this.loadList()
  },
  methods: {
    fmt(v) {
      return v == null || v === '' ? '-' : v
    },
    toFullUrl(url) {
      if (!url) return ''
      const s = String(url).trim()
      if (/^https?:\/\//i.test(s) || s.startsWith('//') || s.startsWith('data:')) return s
      if (s.indexOf('/upload/') === 0 || s.indexOf('upload/') === 0) {
        return `https://oss-pai-s2lxmtw6mbk6ofo9ye-cn-shanghai.oss-cn-shanghai.aliyuncs.com/upload/${s.replace(/^\/?upload\/?/, '')}`
      }
      return s
    },
    resetQuery() {
      this.query.baseName = ''
      this.query.baseCode = ''
      this.query.status = null
      this.query.page = 0
      this.loadList()
    },
    loadList() {
      this.loading = true
      fetchSealBases({
        page: this.query.page,
        size: this.query.size,
        baseName: this.query.baseName || undefined,
        baseCode: this.query.baseCode || undefined,
        status: this.query.status == null ? undefined : this.query.status
      })
        .then((res) => {
          const data = (res && res.data) || {}
          this.list = data.content || []
          this.total = data.totalElements || 0
        })
        .catch(() => {
          this.list = []
          this.total = 0
        })
        .finally(() => {
          this.loading = false
        })
    },
    handlePageChange(page) {
      this.query.page = Math.max(page - 1, 0)
      this.loadList()
    },
    handleSizeChange(size) {
      this.query.size = size
      this.query.page = 0
      this.loadList()
    },
    openForm(row) {
      this.form = row && row.id ? { ...emptyForm(), ...row } : emptyForm()
      this.formVisible = true
      this.$nextTick(() => {
        if (this.$refs.formRef) this.$refs.formRef.clearValidate()
      })
    },
    resetForm() {
      this.form = emptyForm()
    },
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return
        this.saving = true
        const req = this.form.id ? updateSealBase(this.form) : createSealBase(this.form)
        req
          .then(() => {
            this.$message.success(this.form.id ? '已更新' : '已创建')
            this.formVisible = false
            this.loadList()
          })
          .finally(() => {
            this.saving = false
          })
      })
    },
    handleDelete(row) {
      if (!row || !row.id) return
      this.$confirm(`确定删除底座「${row.baseName}」？不影响触点规则。`, '提示', { type: 'warning' })
        .then(() => deleteSealBase(row.id))
        .then(() => {
          this.$message.success('已删除')
          this.loadList()
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.op-btns {
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}
.op-btns >>> .el-button {
  padding: 0 6px;
  margin: 0;
}
.op-btns >>> .op-del {
  color: #f56c6c;
}
</style>
